import { styled } from '@mui/material/styles';
import { TextField, Button, Checkbox, FormControlLabel } from '@mui/material';

// Auth text field with consistent styling
export const AuthTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
  },
}));

// Auth primary gradient button
export const AuthGradientButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: '12px 0',
  width: '100%',
  fontWeight: 700,
  fontSize: '1.1rem',
  borderRadius: 8,
  background: 'linear-gradient(90deg, #2196f3 0%, #21CBF3 100%)',
  boxShadow: '0 4px 20px 0 rgba(33, 203, 243, .15)',
  letterSpacing: 1,
  transition: 'all 0.2s',
  '&:hover': {
    background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
    boxShadow: '0 6px 24px 0 rgba(33, 203, 243, .18)',
    transform: 'translateY(-2px) scale(1.02)',
  },
  '&:disabled': {
    background: theme.palette.grey[300],
    transform: 'none',
    boxShadow: 'none',
  },
}));

// Auth secondary button
export const AuthSecondaryButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: '10px 0',
  width: '100%',
  fontWeight: 600,
  fontSize: '1rem',
  borderRadius: 16,
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  background: 'transparent',
  transition: 'all 0.2s',
  '&:hover': {
    background: theme.palette.primary.main,
    color: 'white',
    transform: 'translateY(-1px)',
  },
}));

// Auth checkbox
export const AuthCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },
}));

// Auth form control label
export const AuthFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: 0,
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
})); 